module.exports = __webpack_public_path__ + "static/media/standard-plant-sphere.8599a217.svg";